enum DoohVenueTypeLevel {
  Parent = 1,
  Child = 2,
  Grandchild = 3,
}

export default DoohVenueTypeLevel;
